<template>
    <div>
        <div class="list-news-grid">
            <div class="row-grid">
                <div class="col-grid-25" v-for="(data, index) in dataArray" :key="index">
                    <div class="item-news">
                        <div class="box-cards">
                            <div class="image-section">
                                <a :href="data.detail_url_web" @click="gtmTrackerGalleryClick(data, index)" class="link">
                                    <img :src="data.thumbnail" @error="data.thumbnail = base_url+'/images/default.jpg'"
                                        :alt="data.title" class="image-item">
                                    <div class="overlay-bg">
                                        <div class="icon_play">
                                            <img :src="base_url+'/images/icon_play.png'" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="description-section">
                                <div class="date">
                                    <img class="calendar" :src="base_url+'/images/icon_calendar.png'" alt="calendar" />
                                    <span>{{ data.date}}</span>
                                </div>
                                <div class="text-title">
                                    <a :href="data.detail_url_web" @click="gtmTrackerGalleryClick(data, index)">
                                        <h3>{{ data.title }}</h3>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row-button">
            <a @click="gtmTrackerBtn" :href="app_url+ url " class="seeMore">See More</a>
        </div>
    </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
export default {
    props: ["relatedData", "url"],
    components: {},

    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            mobile: false,
            currentPage: 0,
            dataArray: []
        };
    },
    created() {
        this.mobile = isMobile;
    },
    watch: {
        relatedData: function(val) {
          console.log(val?.currentPage + ' ' + this.currentPage);
            if(val?.currentPage != this.currentPage){
              this.currentPage = val.currentPage;
              this.dataArray.push(...this.relatedData.relatedData);
            }
        }
    },
    methods: {
        getRelatedData() {
          if(this.relatedData.nextPageUrl){
            this.$emit("getRelatedData");
          }
        },
        gtmTrackerBtn() {
            var data = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href,
                'list': 'Related Video'
            }
            dataLayer.push(data);
        },
        gtmTrackerGalleryClick(data, index) {
            const track = {
                'event': 'galleryClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Gallery Click', 
                'eventDetail.label': data.title, // 'Video Click', 
                'position': index + 1
            }
            dataLayer.push(track);
        },
    }
};
</script>
<style scoped lang="scss">
    .image-section {
        position: relative;
        width: 100%;
        overflow: hidden;
        border-radius: 10px;
        img {
            width: 100%;
            // object-fit: cover;
            // height: 100%;
        }
    }
    .overlay-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.13) 0%,
            rgba(0, 0, 0, 0.58) 100%
        );
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon_play {
            display: flex;
            width: 40px;
        }
    }
    .description-section {
        padding: 10px;
    }
    .date {
        font-size: 14px;
        font-weight: 500;
        display: flex;
        margin-right: 10px;
        position: relative;
        align-items: center;
        color: #727272;
        .calendar {
            max-width: 15px;
            width: 100%;
            margin-right: 5px;
        }
    }
    .row-button {
        margin-top: 20px;
        display: block;
        width: 100%;
        text-align: center;
    }
    .seeMore {
        display: inline-block;
        background: #282828;
        border-radius: 10px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        padding: 10px 20px;
    }
    .text-title a h3{
        color: #fff;
        font-size: 20px;
        max-width: 100%;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
    }
</style>
